import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/crown-white.svg'
import _imports_1 from '@/assets/user-avatar.svg'
import _imports_2 from '@/assets/logo_v2.svg'


const _withScopeId = n => (_pushScopeId("data-v-3572f78b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__container container" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  alt: "premiumIcon",
  class: "header__premium-icon"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "header__avatar",
  src: _imports_1,
  alt: "user",
  width: "40",
  height: "40"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "header__logo",
  alt: "Lily Plants",
  src: _imports_2,
  width: "120",
  height: "29"
}, null, -1))

import { computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from '@/store';

import PcMenu from './PcMenu.vue';
import MobileMenu from './MobileMenu.vue';

import { MODALS } from '@/@types/base';


export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultHeader',
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRoute();

const userEmpty = computed<boolean>(() => store.getters['auth/userEmpty']);

const user = computed(() => store.getters['auth/user']);

const showLoginModal = () => {
  store.dispatch('base/openModal', MODALS.AUTHORIZATION);
};

const navigateToNotifications = () => {
  if (route.name === 'EmailNotifications') {
    return;
  }

  router.push({ name: 'EmailNotifications' });
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(userEmpty))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "header__login-btn",
            onClick: showLoginModal
          }, _toDisplayString(_ctx.$t('form_button_log_in')), 1))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: "header__avatar-container",
            onClick: navigateToNotifications
          }, [
            (_unref(user)?.subscription?.is_premium)
              ? (_openBlock(), _createElementBlock("img", _hoisted_3))
              : _createCommentVNode("", true),
            _hoisted_4
          ])),
      _createVNode(_component_router_link, {
        class: "header__home-link",
        to: "/",
        "data-test": "header-logo"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(PcMenu, { class: "header__pc-menu" }),
      _createVNode(MobileMenu, { class: "header__mob-menu" })
    ])
  ]))
}
}

})